export const storesTableWidths = {
  id: 200,
  store: 600,
  role : 955
}
